import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import 'react-dropdown/style.css';
// import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { Oval } from 'react-loader-spinner';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import * as moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MDButton from 'components/MDButton';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
// import { styled } from '@mui/material/styles';
import Select from 'react-select';
// import { jsPDF } from 'jspdf';
// import html2canvas from "html2canvas";
import * as service from '../../services/service';

function DivisionWiseAbstractLA() {
    const [reportDetailsData, setReportDetailsData] = useState([]);
    const [showDetailsReport, setShowDetailsReport] = useState(false);
    const [civilIDCData, setCivilIDCData] = useState([]);
    const [civilCEOData, setCivilCEOData] = useState([]);
    const [civilSEOData, setCivilSEOData] = useState([]);
    const [civilIDCId, setCivilIDCId] = useState('');
    const [civilCEOId, setCivilCEOId] = useState('');
    const [civilSEOId, setCivilSEOId] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const userLvl = JSON.parse(sessionStorage.getItem('userData')).userLevel;
    const userTp = JSON.parse(sessionStorage.getItem('userData')).userType;
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

    const cellStyle = {
        fontWeight: 'bold',
        fontSize: '14px',
        borderWidth: "1px",
        borderColor: "#aaaaaa",
        borderStyle: 'solid',
    }

    const getCivilSEOs = (id) => {
        fetch(
            service.GET_CIVILSEO_BY_CEO_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilCEOId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilSEOId, label: item.civilSEO }));
                setCivilSEOData(data2);
                if (JSON.parse(sessionStorage.getItem('userData')).civilSEOId > 0) {
                    const seo = ({ label: JSON.parse(sessionStorage.getItem('userData')).civilSEO, value: JSON.parse(sessionStorage.getItem('userData')).civilSEOId });
                    setCivilSEOId(seo);
                }
            });
    };

    const getCivilCEOs = (id) => {
        fetch(
            service.GET_CIVILCEO_BY_IDC_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilIDCId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilCEOId, label: item.civilCEO }));
                setCivilCEOData(data2);
                if (JSON.parse(sessionStorage.getItem('userData')).civilCEOId > 0) {
                    const ceo = ({ label: JSON.parse(sessionStorage.getItem('userData')).civilCEO, value: JSON.parse(sessionStorage.getItem('userData')).civilCEOId });
                    setCivilCEOId(ceo);
                    getCivilSEOs(JSON.parse(sessionStorage.getItem('userData')).civilCEOId);
                }
            });
    };
    const getCivilIDCs = () => {
        fetch(
            service.CIVILIDC_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilIDCId, label: item.civilIDC }));
                setCivilIDCData(data2);
                const idc = ({ label: JSON.parse(sessionStorage.getItem('userData')).civilIDC, value: JSON.parse(sessionStorage.getItem('userData')).civilIDCId });
                setCivilIDCId(idc);
                getCivilCEOs(JSON.parse(sessionStorage.getItem('userData')).civilIDCId);
            });
    };

    function GetReport() {
        const errs = {};
        fetch(
            service.GET_DIVISION_WISE_ABSTRACT_LA,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilSEOId: civilSEOId.value,
                    FromDate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : null,
                    ToDate: toDate ? moment(toDate).format("MM/DD/YYYY") : null
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 0) {
                    errs[".invalid"] = 'No Data Found!';
                    setErrors(errs);
                    setShowDetailsReport(false);
                }
                else if (result.length > 0) {
                    setShowDetailsReport(true);
                    setReportDetailsData(result);
                    errs[".invalid"] = '';
                    setErrors(errs);
                }
            });
    }

    useEffect(() => {
        if (userTp === "User") {
            getCivilIDCs();
        }

    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!civilCEOId) {
            isValid = false;
            errs[".ceo"] = "Please enter Civil CEO";
        }
        if (!civilSEOId) {
            isValid = false;
            errs[".seo"] = "Please enter Civil SEO";
        }
        if (!fromDate) {
            isValid = false;
            errs[".fromdate"] = "Please select From Date";
        }
        if (!toDate) {
            isValid = false;
            errs[".todate"] = "Please select To Date";
        }
        setErrors(errs);
        return isValid;
    }

    const submitHandler = e => {
        setReportDetailsData([]);
        setShowDetailsReport(false);
        e.preventDefault();
        setLoading(true);
        if (validate()) {
            GetReport();
        }
        setLoading(false);
    }

    const CivilIDCChangeHandler = (ev) => {
        setCivilIDCId(ev);
        setCivilCEOData([]);
        getCivilCEOs(ev.value);
    }
    const CivilCEOChangeHandler = (ev) => {
        setCivilCEOId(ev);
        setCivilSEOData([]);
        getCivilSEOs(ev.value);
    }
    const CivilSEOChangeHandler = (ev) => {
        setCivilSEOId(ev);
    }

    // const BpIcon = styled('span')(({ theme }) => ({
    //     borderRadius: '50%',
    //     width: 16,
    //     height: 16,
    //     boxShadow:
    //         theme.palette.mode === 'dark'
    //             ? '0 0 0 1px rgb(16 22 26 / 40%)'
    //             : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    //     backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    //     backgroundImage:
    //         theme.palette.mode === 'dark'
    //             ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
    //             : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    //     '.Mui-focusVisible &': {
    //         outline: '2px auto rgba(19,124,189,.6)',
    //         outlineOffset: 2,
    //     },
    //     'input:hover ~ &': {
    //         backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    //     },
    //     'input:disabled ~ &': {
    //         boxShadow: 'none',
    //         background:
    //             theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    //     },
    // }));
    // const BpCheckedIcon = styled(BpIcon)({
    //     backgroundColor: '#137cbd',
    //     backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    //     '&:before': {
    //         display: 'block',
    //         width: 16,
    //         height: 16,
    //         backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    //         content: '""',
    //     },
    //     'input:hover ~ &': {
    //         backgroundColor: '#106ba3',
    //     },
    // });

    const getHeadersForReport = () => {
        let headers = '';
        if (reportDetailsData.length > 0) {
            const column = reportDetailsData[0];
            const title = Object.keys(column);
            const head = title.map((data) =>
                <TableCell key={data} style={cellStyle}>{data}</TableCell>
            )
            headers = head;
        }
        return headers;
    }

    const getRowsForReport = () => {
        let row = '';
        if (reportDetailsData.length > 0) {
            const column = reportDetailsData[0];
            const title = Object.keys(column);
            const rw = reportDetailsData.map((data) =>
                <TableRow>
                    {
                        title.map((i) =>
                            <TableCell style={cellStyle}>{data[i]}</TableCell>
                        )
                    }
                </TableRow>
            )
            row = rw;
        }
        return row;
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>

                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Division Wise Abstract(LA) Report
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Table aria-label="simple table">
                                <TableRow>
                                    <TableCell>
                                        <Select
                                            name="Civil IDC"
                                            options={civilIDCData} placeholder="Select Civil IDC"
                                            value={civilIDCId}
                                            onChange={CivilIDCChangeHandler}
                                            isSearchable
                                            styles={selectStyles}
                                            isDisabled
                                        />
                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilIDCId"]}</div>
                                    </TableCell>
                                    <TableCell>
                                        <Select
                                            name="Civil CEO"
                                            options={civilCEOData} placeholder="Select Civil CEO"
                                            value={civilCEOId}
                                            onChange={CivilCEOChangeHandler}
                                            isSearchable
                                            styles={selectStyles}
                                            isDisabled={userLvl === 'Civil CEO' || userLvl === 'Civil Division'}
                                        />
                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".ceo"]}</div>
                                    </TableCell>
                                    <TableCell>
                                        <Select
                                            name="Civil SEO"
                                            options={civilSEOData} placeholder="Select Civil SEO"
                                            value={civilSEOId}
                                            onChange={CivilSEOChangeHandler}
                                            isSearchable
                                            styles={selectStyles}
                                            isDisabled={userLvl === 'Civil Division'}
                                        />
                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".seo"]}</div>
                                    </TableCell>
                                    <TableCell />
                                </TableRow>
                                <TableRow>
                                    <TableCell width="25%" align="right" style={{ fontSize: '12px' }}>
                                        From Date :
                                    </TableCell>
                                    <TableCell width="25%" style={{ fontSize: '12px' }}>
                                        <DatePicker
                                            id="fromDate"
                                            selected={fromDate}
                                            onChange={date => setFromDate(date)}
                                            dateFormat="MM/dd/yyyy"
                                        />
                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".fromdate"]}</div>
                                    </TableCell>
                                    <TableCell width="25%" align="right" style={{ fontSize: '12px' }}>
                                        To Date :
                                    </TableCell>
                                    <TableCell style={{ fontSize: '12px' }}>
                                        <DatePicker
                                            id="toDate"
                                            selected={toDate}
                                            onChange={date => setToDate(date)}
                                            dateFormat="MM/dd/yyyy"
                                        />
                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".todate"]}</div>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan="6" align="center">
                                        <MDBox mt={4} mb={1} textAlign="center">
                                            {loading ?
                                                <Oval
                                                    heigth="20"
                                                    width="20"
                                                    color='grey'
                                                    ariaLabel='loading'
                                                />
                                                :
                                                <MDButton color="info" onClick={submitHandler}>
                                                    Show
                                                </MDButton>
                                            }
                                            {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                        </MDBox>
                                    </TableCell>
                                </TableRow>
                            </Table>
                            <Card style={{ alignItems: 'center' }}>
                                {loading ?
                                    <Oval
                                        heigth="100"
                                        width="100"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                    <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                        <Table id="dvDetailReport">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan="15">
                                                        <Table>
                                                            <TableRow>
                                                                <TableCell colSpan="4" align="center" style={{ fontWeight: 'bold', fontSize: '20px' }}>
                                                                    Civil Division wise Abstract - Land Acquisition
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell width="25%" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                    Civil IDC : {JSON.parse(sessionStorage.getItem('userData')).civilIDC}
                                                                </TableCell>
                                                                <TableCell width="25%" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                    Civil CEO : {civilCEOId ? civilCEOId.label : ''}
                                                                </TableCell>
                                                                <TableCell width="20%" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                    Civil SEO : {civilSEOId ? civilSEOId.label : ''}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell width="20%" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                    From Date : {moment(fromDate).format("DD/MM/YYYY")}
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                    To Date : {moment(toDate).format("DD/MM/YYYY")}
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }} />
                                                            </TableRow>
                                                        </Table>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                    {getHeadersForReport()}
                                                </TableRow>
                                                {getRowsForReport()}
                                                {/* <TableRow>
                        <TableCell align="right" colSpan="15" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            <br />
                            <br />
                            <br />
                            {JSON.parse(sessionStorage.getItem('userData')).userName}
                            <br />
                            {JSON.parse(sessionStorage.getItem('userData')).designation}
                            <br />
                            {JSON.parse(sessionStorage.getItem('userData')).mechanicalSubDivision}
                        </TableCell>
                    </TableRow> */}
                                            </TableBody>
                                        </Table>

                                        <br />
                                        <Table>
                                            <TableRow>
                                                <TableCell align="center">
                                                    {showDetailsReport ?
                                                        <ReactHTMLTableToExcel table="dvDetailReport" className="info"
                                                            filename="ReportData" sheet="Sheet" buttonText="EXPORT TO EXCEL"
                                                        />
                                                        : null}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>{errors[".invalid"]}</TableCell>
                                            </TableRow>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Card>

                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default DivisionWiseAbstractLA;
